export enum GLOBAL_STYLE_VARIABLES {
  fullScreenRatio = '--full-screen-ratio',
  baseRemRatio = '--base-rem-ratio',
  mobileRemRatio = '--mobile-rem-ratio',
  mobilePadding = '--mobile-padding',
  scrollbarWidth = '--scrollbar-width',
  scrollbarCompensation = '--scrollbar-compensation',
}
